import { render, staticRenderFns } from "./1688Order.vue?vue&type=template&id=79fe097c&scoped=true"
import script from "./1688Order.vue?vue&type=script&lang=js"
export * from "./1688Order.vue?vue&type=script&lang=js"
import style0 from "./1688Order.vue?vue&type=style&index=0&id=79fe097c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fe097c",
  null
  
)

export default component.exports